















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsSvgiconQuestion extends Vue {
  // Props
  @Prop({ type: String, default: '#6e6bce', })
  iconColor: string;

  @Prop({ type: String, default: 'default', })
  hoverColor: string;

  // computed
  get classes() {
    return {
      [`question_${this.hoverColor}`]: true,
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/svgicon/Question.vue